import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Stack,
  Box,
  Button,
  IconButton,
  RadioGroup,
  Radio,
  FormControlLabel,
} from '@mui/material';
import { X } from 'lucide-react';

export const TimeSeriesConfigModal = ({
  isOpen = false,
  onClose = () => {},
  config = { display: 'chart', size: 'medium', range: '10m' },
  onChange = () => {},
  title = 'This time series',
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
          {title}
        </Typography>
        <IconButton size="small" onClick={onClose}>
          <X style={{ width: 18, height: 18 }} />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 2.5 }}>
        <Stack spacing={2.5}>
          {/* Display Mode */}
          <Box>
            <Typography variant="caption" sx={{ fontWeight: 700, textTransform: 'uppercase', color: 'text.secondary', display: 'block', mb: 1 }}>
              Display Mode
            </Typography>
            <RadioGroup
              value={config.display || 'chart'}
              onChange={(e) => onChange({ display: e.target.value })}
            >
              {[
                { value: 'chart', label: 'Chart' },
                { value: 'value', label: 'Current value' },
                { value: 'moving_average', label: 'Moving average' },
              ].map((item) => (
                <FormControlLabel
                  key={item.value}
                  value={item.value}
                  control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#006951' } }} />}
                  label={<Typography variant="body2" sx={{ fontSize: '0.8rem' }}>{item.label}</Typography>}
                />
              ))}
            </RadioGroup>
          </Box>

          {/* Chart Size */}
          <Box>
            <Typography variant="caption" sx={{ fontWeight: 700, textTransform: 'uppercase', color: 'text.secondary', display: 'block', mb: 1 }}>
              Chart Size
            </Typography>
            <RadioGroup
              value={config.size || 'medium'}
              onChange={(e) => onChange({ size: e.target.value })}
            >
              {[
                { value: 'small', label: 'Small' },
                { value: 'medium', label: 'Medium' },
                { value: 'large', label: 'Large' },
              ].map((item) => (
                <FormControlLabel
                  key={item.value}
                  value={item.value}
                  control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#006951' } }} />}
                  label={<Typography variant="body2" sx={{ fontSize: '0.8rem' }}>{item.label}</Typography>}
                />
              ))}
            </RadioGroup>
          </Box>

          {/* All Time Series Range */}
          <Box sx={{ pt: 1.5, borderTop: '1px solid', borderColor: 'divider' }}>
            <Typography variant="caption" sx={{ fontWeight: 700, textTransform: 'uppercase', color: 'text.secondary', display: 'block', mb: 1 }}>
              Chart Range (All Series)
            </Typography>
            <RadioGroup
              value={config.range || '10m'}
              onChange={(e) => onChange({ range: e.target.value })}
            >
              {[
                { value: '1m', label: 'Last minute' },
                { value: '10m', label: 'Last ten minutes' },
                { value: '1h', label: 'Last hour' },
                { value: '8h', label: 'Last eight hours' },
                { value: '1d', label: 'Last day' },
              ].map((item) => (
                <FormControlLabel
                  key={item.value}
                  value={item.value}
                  control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#006951' } }} />}
                  label={<Typography variant="body2" sx={{ fontSize: '0.8rem' }}>{item.label}</Typography>}
                />
              ))}
            </RadioGroup>
          </Box>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="contained" fullWidth sx={{ bgcolor: '#006951', '&:hover': { bgcolor: '#005441' } }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
